import { createSlice } from "@reduxjs/toolkit";
import { fetchMmvAction } from "../Actions/fetchMmvAction";

export const getMmvReducer = createSlice({
  name: "fetchVehicleDetails",
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
  },
  reducers: {
    updateVehicleInfoAction: (state, action) => {
      state.data = action?.payload || {};
    },
    resetVehicleData: (state, action) => {
      state.data = undefined
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchMmvAction.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchMmvAction.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchMmvAction.rejected, (state, action) => {
      console.error("Error", action.payload);
      state.isError = true;
      state.isLoading = false;
    });
  },
});

export const { updateVehicleInfoAction, resetVehicleData } = getMmvReducer.actions;